module.exports = __webpack_public_path__ + "static/media/V75-label.f0d582a6.png";